// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"51b2ccc3","307":"19e0b68a","423":"62f19dda","453":"59df9321","791":"b906e124"}[chunkId] + ".chunk.js";
};